/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthenticationConfiguration } from '../../models/authentication-configuration';
import { UpdateAuthenticationConfigurationRequest } from '../../models/update-authentication-configuration-request';

export interface UpdateAuthenticationConfiguration_1$Params {
  organizationId: string;
  
    /**
     * Employee authentication configuration to be updated.
     */
    body: UpdateAuthenticationConfigurationRequest
}

export function updateAuthenticationConfiguration_1(http: HttpClient, rootUrl: string, params: UpdateAuthenticationConfiguration_1$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthenticationConfiguration>> {
  const rb = new RequestBuilder(rootUrl, updateAuthenticationConfiguration_1.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthenticationConfiguration>;
    })
  );
}

updateAuthenticationConfiguration_1.PATH = '/v1/organizations/{organizationId}/configuration/employees/authentication';
